module.exports = __webpack_public_path__ + "img/SLT_5949-Bearbeitet.987d992f.jpg";